import Complaints from "./Complaints.containter";

export default Complaints;